module.exports = __webpack_public_path__ + "static/media/dflogo.1a7a33f5.png";